import React from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import SvgIcon from '../../../Helpers/Svg/SvgIcon';

import "./Cta.scss";

export default function Cta({ data, customData, action }) {
  const {iconName, value, buttonText, backgroundImageUrl} = !customData ? data : customData;

  return (
    <div className="cta-wrapper" style={{'--cta-background-image': `url(${backgroundImageUrl})`}}>
      <Container>
        <div className="cta-container">
          <div className="cta-content">
            <div className="icon-container">
              <SvgIcon viewBox={"0 0 40 40"} iconName={iconName} />
            </div>
            <p dangerouslySetInnerHTML={{__html: value}}></p>
            <Button onClick={action} className="buttonStyles" variant="contained">
              {buttonText}
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}

Cta.propTypes = {
  data: PropTypes.object.isRequired,
  customData: PropTypes.object,
  action: PropTypes.func,
};
